document.addEventListener('turbolinks:load', function () {
    if ($('.contractor-portal.onboarding.new, .contractor-portal.onboarding.create, .contractor-portal.settings.index, .contractor-invitation-card, .contractors.edit').length === 0) {
        return false
    }

    // Jurisdiction change -> fetch types and update UI constraints
    $(document).on('change', '.contractor-client-select', function () {
        var organizationId = $(this).val()
        var jurisdictionNestedField = $(this).parents('.jurisdictionNestedFields')
        handleContractorTypes(jurisdictionNestedField, organizationId)
        // Update jurisdiction duplicate prevention and add-button visibility
        updateJurisdictionOptions()
    })

    function handleContractorTypes(elem, organizationId) {
        if (!organizationId) {
            // Clear contractor type selects if no org selected
            $(elem).find('.dynamic-contractor-types').each(function(){
                $(this).empty()
            })
            updateContractorTypeOptions($(elem))
            return
        }
        $.ajax({
            url: `/organizations/${organizationId}/contractor_registration_fees/client_contractor_types`,
            type: 'GET',
            success: function (response) {
                var contractorTypes = response.contractor_types || []
                var $typeSelects = $(elem).find('.nested-fields:visible .dynamic-contractor-types')

                // Rebuild options for each select individually, preserving current value when possible
                $typeSelects.each(function(){
                    var $sel = $(this)
                    var currentVal = $sel.val()

                    $sel.empty()
                    // Add prompt option to avoid auto-selecting a value
                    $sel.append('<option value="" disabled="true">Select any one</option>')

                    contractorTypes.forEach(function (contractorType) {
                        var opt = $('<option/>', { value: contractorType, text: contractorType })
                        $sel.append(opt)
                    })

                    // Restore previous selection if still available
                    if (currentVal && contractorTypes.includes(currentVal)) {
                        $sel.val(currentVal)
                    } else {
                        // Ensure no auto-selection when previous value is not available
                        $sel.val('')
                    }
                })

                // After populating, enforce uniqueness/hide add button
                updateContractorTypeOptions($(elem))
            }
        })
    }

    // Prevent duplicate jurisdictions and toggle add button
    function updateJurisdictionOptions() {
        var $selects = $('.client-contractor-section .nested-fields:visible .contractor-client-select')
        if ($selects.length === 0) return

        // Collect all option values (excluding blank) from the first select
        var allOptionValues = []
        $selects.first().find('option').each(function(){
            var val = $(this).attr('value')
            if (val) { allOptionValues.push(val) }
        })
        allOptionValues = Array.from(new Set(allOptionValues))

        // Currently selected values
        var selectedValues = $selects.map(function(){ return $(this).val() }).get().filter(function(v){ return v })

        // For each select, disable options already selected in other selects
        $selects.each(function(){
            var currentVal = $(this).val()
            $(this).find('option').each(function(){
                var val = $(this).attr('value')
                if (!val) return // skip prompt/blank
                var shouldDisable = selectedValues.includes(val) && val !== currentVal
                $(this).prop('disabled', shouldDisable)
            })
        })

        // Toggle add jurisdiction button
        var remaining = allOptionValues.filter(function(v){ return !selectedValues.includes(v) }).length
        var $addBtn = $('.client-contractor-section .add-local-jurisdiction')
        if (remaining <= 0 || $selects.length === allOptionValues.length) {
            $addBtn.addClass('d-none').prop('disabled', true)
        } else {
            $addBtn.removeClass('d-none').prop('disabled', false)
        }
    }

    // Within a jurisdiction nested field, prevent duplicate contractor types and toggle add button
    function updateContractorTypeOptions($jurisdictionNested) {
        // var $container = $jurisdictionNested.find('.contractorTypeSelection')
        // if ($container.length === 0) return
        // var $typeSelects = $container.find('.nested-fields:visible .dynamic-contractor-types')
        // if ($typeSelects.length === 0) return
        //
        // // All available types from the first select's options
        // var allTypes = []
        // $typeSelects.first().find('option').each(function(){
        //     var v = $(this).attr('value')
        //     if (v) allTypes.push(v)
        // })
        // allTypes = Array.from(new Set(allTypes))
        //
        // // Selected types in this jurisdiction
        // var selected = $typeSelects.map(function(){ return $(this).val() }).get().filter(function(v){ return v })
        //
        // // Disable duplicates across sibling selects
        // $typeSelects.each(function(){
        //     var currentVal = $(this).val()
        //     $(this).find('option').each(function(){
        //         var v = $(this).attr('value')
        //         if (!v) return
        //         var shouldDisable = selected.includes(v) && v !== currentVal
        //         $(this).prop('disabled', shouldDisable)
        //     })
        // })
        //
        // // Toggle add contractor-type button inside this container
        // var remaining = allTypes.filter(function(v){ return !selected.includes(v) }).length
        // var $addTypeBtn = $container.find('.add-contractor-type')
        // if (remaining <= 0 || $typeSelects.length === allTypes.length) {
        //     $addTypeBtn.addClass('d-none').prop('disabled', true)
        // } else {
        //     $addTypeBtn.removeClass('d-none').prop('disabled', false)
        // }
    }

    // When a contractor type select changes, update duplicate prevention in its container
    $(document).on('change', '.dynamic-contractor-types', function(){
        var $jurisdictionNested = $(this).closest('.jurisdictionNestedFields')
        updateContractorTypeOptions($jurisdictionNested)
    })

    // Cocoon events for inserted/removed contractor types
    $('.client-contractor-section')
      .on('cocoon:after-insert', '.contractorTypeSelection', function(e, insertedItem) {
          var $jurisdictionNested = $(this).parents('.jurisdictionNestedFields')
          var organizationId = $jurisdictionNested.find('.contractor-client-select').val()
          handleContractorTypes($jurisdictionNested, organizationId)
          toggleRequiredField(insertedItem, true)
      })
      .on('cocoon:after-remove', '.contractorTypeSelection', function(e, removedItem){
          var $jurisdictionNested = $(this).parents('.jurisdictionNestedFields')
          updateContractorTypeOptions($jurisdictionNested)
          toggleRequiredField(removedItem, false)
      })

    // Cocoon events for inserted/removed jurisdictions
    $('.client-contractor-section')
      .on('cocoon:after-insert', function(e, insertedItem){
          // insertedItem is the new jurisdiction block when adding Local Jurisdiction
          updateJurisdictionOptions()
          var organizationId = $(insertedItem).find('.contractor-client-select').val()
          handleContractorTypes($(insertedItem), organizationId)
          toggleRequiredField(insertedItem, true)
      })
      .on('cocoon:after-remove', function(e, removedItem){
          updateJurisdictionOptions()
          toggleRequiredField(removedItem, false)
          removedItem.find('input[min][type="date"]').removeAttr("min"); // min attribute causes native validation
      })

    // toggle .client-contractor-section when applicant type changes
    function toggleContractorSection(showSection) {
        var $section = $('.client-contractor-section')
        // disable non-hidden inputs when hiding to prevent browser native validation
        // (e.g. date fields with min= attribute trigger "not focusable" errors when hidden)
        var $inputs = $section.find('input:not([type="hidden"]), select, textarea')
        if (showSection) {
            $section.removeClass('d-none')
            $inputs.prop('disabled', false)
            toggleRequiredField($section, true)
        } else {
            $section.addClass('d-none')
            $inputs.prop('disabled', true)
            toggleRequiredField($section, false)
        }
        updateJurisdictionOptions()
    }

    // #user_contractor_role is the select used on the admin edit/invite pages only;
    // onboarding/settings use radio buttons with their own toggle in
    // user_onboarding_form.js, which never touches disabled state - scoping this
    // to pages with the select keeps the two from fighting over the same section.
    if ($('#user_contractor_role').length) {
        $(document).on('change', '#user_contractor_role', function () {
            var role = $(this).val()
            toggleContractorSection(!role || role === 'Contractor')
        })

        // Initial pass on page load
        // disable fields if not visibile on FE to prevent unintended validation issue
        if ($('.client-contractor-section').hasClass('d-none')) {
            $('.client-contractor-section').find('input:not([type="hidden"]), select, textarea').prop('disabled', true)
        }
    }
    updateJurisdictionOptions()
    $('.client-contractor-section .jurisdictionNestedFields').each(function(){
        updateContractorTypeOptions($(this))
    })
    // add requiredField to existing nested-fields
    $('.client-contractor-section .nested-fields:visible').each(function() {
        toggleRequiredField($(this), true)
    })

    function toggleRequiredField(item, required) {
        if (required) {
            item.find('.is_required_input').each(function () {
                $(this).addClass('requiredField')
            })
        } else {
            item.find('.is_required_input').each(function () {
                $(this).removeClass('requiredField')
            })
        }
    }
});